import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { ErrorMessageModule } from '../error-message/error-message.module';
import { TooltipMessageModule } from '../tooltip-message/tooltip-message.module';
import { DatePicker } from '../utils/models/DatePicker';
import { DatePickerComponent } from './date-picker.component';
import { DatePickerService } from './date-picker.service';


@NgModule({
  declarations: [DatePickerComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorMessageModule,
    TooltipMessageModule,
    MatIconModule,
    MatTooltipModule,
    NgbDatepickerModule
  ],
  exports: [DatePickerComponent]
})
export class DatePickerModule {
  static forRoot(datePicker: DatePicker = new DatePicker()): ModuleWithProviders<DatePickerModule> {
    return {
      ngModule: DatePickerModule,
      providers: [
        { provide: 'DATE_PICKER_SHOW_LABEL', useValue: datePicker.showLabel },
        { provide: 'DATE_PICKER_AUTOCOMPLETE', useValue: datePicker.autocomplete },
        { provide: 'DATE_PICKER_NO_AUTO_COMPLETE_NULL', useValue: datePicker.noAutoCompleteNull },
        { provide: 'DATE_PICKER_FOCUS_INITIAL', useValue: datePicker.focusInitial },
        { provide: 'DATE_PICKER_VALIDATOR_MESSAGE', useValue: datePicker.validatorMessage },
        { provide: 'DATE_PICKER_TOOLTIP_MESSAGE', useValue: datePicker.tooltipMessage },
        { provide: 'DATE_PICKER_SUBMITTED', useValue: datePicker.submitted },
        { provide: 'DATE_PICKER_VALIDATOR_ALERT', useValue: datePicker.validatorAlert },
        DatePickerService
      ]
    }
  }
}
